import * as React from "react";
import { File as FileIcon, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileWithProgress } from "@/views/drive/modals/uploadModal/types";
import { processNewFiles } from "@/views/drive/modals/uploadModal/helpers";

interface UploadExistsFilesConfirmationModalProps {
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<FileWithProgress[]>>;
  setExistFiles: React.Dispatch<React.SetStateAction<File[]>>;
  handleUpload: (files: FileWithProgress[]) => Promise<void>;
}

export const UploadExistsFilesConfirmationModal: React.FC<UploadExistsFilesConfirmationModalProps> = ({
  files,
  setFiles,
  setExistFiles,
  handleUpload,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const handleClose = () => {
    setIsOpen(false);
    setExistFiles([]);
  };

  const handleConfirm = () => {
    const newFiles = processNewFiles(files);

    setFiles(prevFiles => [...prevFiles, ...newFiles]);
    void handleUpload(newFiles);
    setExistFiles([]);
  };

  const removeFile = (file: File) => {
    setExistFiles(prevFiles => prevFiles.filter(f => f.name !== file.name));
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Warning some file exists</DialogTitle>
        </DialogHeader>
        <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
          <p className="text-md m-2 text-gray-500">
            Following files already exist in the folder. Do you want to upload them?
          </p>
          <div className="max-h-[220px] overflow-y-auto">
            {files.map(file => (
              <div key={file.name} className="flex justify-between">
                <div className="flex items-center font-medium">
                  <FileIcon className="mr-2 h-4 w-4" />
                  {file.name}
                </div>

                <Button variant="ghost" size="sm" onClick={() => removeFile(file)}>
                  <X className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-4 flex justify-between">
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>

          <Button onClick={handleConfirm}>Upload</Button>
        </div>
      </DialogContent>{" "}
    </Dialog>
  );
};
